<!--
 * @Description: 加油劵商品详情
 * @Author: yl
 * @Date: 2021-06-08 14:59:06
 * @LastEditTime: 2021-06-17 17:57:13
 * @LastEditors: yl
-->
<template>
    <div class="buybar-container home">
        <div class="scrollbar-container shop-info">
            <zbSwiper :data="info.banner" :options="{autoplay:3000}" v-model="activateIndex" designHeight="400"
                class="swiper-img" v-slot:default="{ item }">
                <div class="img bg-contain" :style="{backgroundImage: 'url(' + item + ')'}"
                    @click="onShowImg(activateIndex)"></div>
            </zbSwiper>
            <div class="head">
                <div class="fz_30">{{info.name}}</div>
                <div class="bh bstart">
                    <div class="bg-contain ico-maintenance"></div>
                    <div class="b1">
                        <span class="fz_40 c_red">{{info.price}}</span>
                    </div>
                </div>
            </div>
            <div class="numberStyle border-bottom bh bstart">
                <div class="b1">
                    <span class="fz_30 black">兑换数量</span>
                    <span class="fz_24 gray">(限购1件)</span>
                </div>
                <van-stepper v-model="info.count" min="1" :max="1" integer disabled :long-press="false" />
            </div>
            <div class="fold fz_28">
                <div class="bh down-container">
                    说明
                    <div class="ico-win bg-contain"></div>
                    <div class="text b1">1.仅限下单手机号使用</div>
                    <div class="down-container-el" @click="onFoldClick">
                        <div class="ico-down bg-contain" :class="foldingCls"></div>
                    </div>
                </div>
                <div v-if="!isFolding">
                    <div class="bh fold-list">
                        <div class="ico-win bg-contain"></div>
                        <div class="text b1">2.关注油总管公众号后使用</div>
                    </div>
                    <div class="bh fold-list">
                        <div class="ico-win bg-contain"></div>
                        <div class="text b1">3.仅限有效期内使用</div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="titlebg fz_30 tc bg-contain">产品介绍</div>
            <div class="content" v-html="info.description"></div>
        </div>
        <validation-observer v-slot="{ invalid }">
            <div class="buybar bh bc">
                <validation-provider rules="required|mobile" name="手机号码" v-slot="{ errors }" class="b1">
                    <van-field v-model="info.telephone" clearable maxlength="11" placeholder="请输入手机号码">
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <van-button class="btn btn-buy fz_28" :disabled="invalid||info.ifEmpty" @click="onBuyClick(info)">
                    {{btnText}}</van-button>
            </div>
        </validation-observer>
        <dialogImg ref="dialogImg" :data="info.banner"></dialogImg>
    </div>
</template>
<script>
import { drivingInfo } from "@/api/car";
import { routeCache } from "@/mixin/cache";
import dialogImg from "@/components/dialog/Img";
import zbSwiper from "@/components/swiper/Container";
import { user } from "@/mixin/user";
export default {
    mixins: [routeCache, user],
    name: "FeeOilExchangeInfo",
    components: { zbSwiper, dialogImg },
    data() {
        return {
            activateIndex: 0,
            isFolding: true,
            info: {}
        };
    },
    computed: {
        userInfo() {
            return this.$store.getters.userInfo;
        },
        btnText() {
            return this.info.ifEmpty ? "已售罄" : "立即购买";
        },
        foldingCls() {
            return this.isFolding ? "" : "folding";
        }
    },

    methods: {
        userLoginend() {
            const me = this,
                params = me.getCache();
            drivingInfo(params.id).then(res => {
                me.info = res.data;
                me.info.count = 1;
                me.info.telephone = me.userInfo.telephone;
            });
        },
        onShowImg(v) {
            this.$refs.dialogImg.onShowImg(v);
        },
        onBuyClick(item) {
            this.$router.push({
                name: "CartOrderConfirm",
                params: {
                    isCart: false,
                    orderType: 2,
                    telephone: item.telephone,
                    confirmList: [
                        {
                            id: item.id,
                            goodsQuantity: item.count,
                            goodsVM: item
                        }
                    ]
                },
                query: { orderEndPage: 'CartOrderGasCouponConsequence' }
            });
        },
        onFoldClick() {
            this.isFolding = !this.isFolding;
        }
    }
};
</script>
<style scoped lang="scss">
.folding {
    @include rotate(180deg);
}
/deep/ .van-cell {
    padding: 0 30px;
    //输入内容
    .van-field__control {
        font-size: 34px;
    }
}
.scrollbar-container {
    background-color: #ffffff;
    .head {
        margin: 0 29px 0 30px;
        padding: 40px 0 30px 0;
        border-bottom: 1px solid #dcdcdc;
        .ico-maintenance {
            width: 28px;
            height: 28px;
            margin-right: 10px;
        }
    }
    .numberStyle {
        padding: 40px 30px;
    }
}
.btn-buy {
    width: 300px;
}
.border-bottom {
    &:after {
        width: calc(100% - 60px);
    }
}
.fold {
    padding: 47px 30px 59px 30px;
    color: #666;
    .ico-win {
        width: 24px;
        height: 24px;
        margin: 8px 12px 0 29px;
    }
    .text {
        color: #333;
    }
    .down-container {
        position: relative;
        .down-container-el {
            position: absolute;
            padding: 30px;
            right: 0;
            top: -15px;
        }
    }
    .ico-down {
        width: 33px;
        height: 18px;
    }
    .fold-list {
        padding: 43px 20px 0 56px;
    }
}
.line {
    background: #f1f2f3;
}
</style>
<style scoped>
.content >>> img {
    width: 100% !important;
}
</style>